'use-strict';

var TYPE_BOOK = 'BOOK';
module.exports.TYPE_BOOK = TYPE_BOOK;

var TYPE_ORDER = 'ORDER';
module.exports.TYPE_ORDER = TYPE_ORDER;

var TYPE_SHOP = 'SHOP';
module.exports.TYPE_SHOP = TYPE_SHOP;

var TYPE_LEARN_MORE = 'LEARN_MORE';
module.exports.TYPE_BOOK = TYPE_LEARN_MORE;

var TYPE_SIGN_UP = 'SIGN_UP';
module.exports.TYPE_BOOK = TYPE_SIGN_UP;

var TYPE_CALL = 'CALL';
module.exports.TYPE_CALL = TYPE_CALL;

var CTA_DATA = {
  [TYPE_BOOK]: 'BOOK',
  [TYPE_ORDER]: 'ORDER',
  [TYPE_SHOP]: 'SHOP',
  [TYPE_LEARN_MORE]: 'LEARN_MORE',
  [TYPE_SIGN_UP]: 'SIGN_UP',
  [TYPE_CALL]: 'CALL',
}
module.exports.CTA_DATA = CTA_DATA;

var CTA_LABEL = {
  [CTA_DATA.BOOK]: 'Book',
  [CTA_DATA.CALL]: 'Call',
  [CTA_DATA.SHOP]: 'Shop',
  [CTA_DATA.ORDER]: 'Order',
  [CTA_DATA.LEARN_MORE]: 'Learn More',
  [CTA_DATA.SIGN_UP]: 'Sign up',
}
module.exports.CTA_LABEL = CTA_LABEL;